import { flightBookingRoles as bookingRoles } from '@/utils/flightBookingAccess'

export default {
  path: '/flights',
  component: () => import('@/views/flights/Index'),
  redirect: { name: 'flights-bookings' },
  meta: {
    title: 'Flights',
    roles: bookingRoles
  },
  children: [
    {
      path: 'aviasales',
      name: 'flights-aviasales',
      component: () => import('@/views/flights/aviasales/Index'),
      meta: {
        title: 'Aviasales',
        roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'reservation_supervisor', 'reservation_manager']
      }
    },
    {
      path: 'bookings',
      component: () => import('@/views/flights/bookings/Layout'),
      meta: {
        title: 'Flight bookings',
        mainBackground: '#fafafa',
        fullHeightMain: true,
        roles: bookingRoles
      },
      children: [
        {
          path: '',
          name: 'flights-bookings',
          component: () => import('@/views/flights/bookings/Index'),
          meta: {
            title: 'Flight bookings',
            mainBackground: '#fafafa',
            fullHeightMain: true,
            roles: bookingRoles
          }
        },
        {
          path: 'archive',
          name: 'flights-bookings-archive',
          component: () => import('@/views/flights/bookings/Archive'),
          meta: {
            title: 'Flight bookings',
            mainBackground: '#fafafa',
            fullHeightMain: true,
            roles: bookingRoles
          }
        },
        {
          path: 'cancelled',
          name: 'flights-bookings-cancelled',
          component: () => import('@/views/flights/bookings/Cancelled'),
          meta: {
            title: 'Flight bookings',
            mainBackground: '#fafafa',
            fullHeightMain: true,
            roles: bookingRoles
          }
        }
      ]
    },
    {
      path: 'bookings/:id',
      name: 'flights-bookings-detail',
      component: () => import('@/views/flights/bookings/Detail'),
      redirect: { name: 'flights-bookings-detail-overview' },
      meta: {
        title: 'Flight booking',
        roles: bookingRoles
      },
      children: [
        {
          path: '',
          name: 'flights-bookings-detail-overview',
          component: () => import('@/views/flights/bookings/Overview'),
          meta: {
            title: 'Flight booking',
            roles: bookingRoles
          }
        },
        {
          path: 'overview',
          redirect: { name: 'flights-bookings-detail-overview' },
          meta: {
            title: 'Flight booking',
            roles: bookingRoles
          }
        },
        {
          path: 'finance',
          name: 'flights-bookings-detail-finance',
          component: () => import('@/views/flights/bookings/Finance'),
          meta: {
            title: 'Flight booking',
            roles: bookingRoles
          }
        },
        {
          path: 'emails',
          name: 'flights-bookings-detail-emails',
          component: () => import('@/views/flights/bookings/Emails'),
          meta: {
            title: 'Flight booking',
            roles: bookingRoles
          }
        },
        {
          path: 'history',
          name: 'flights-bookings-detail-history',
          component: () => import('@/views/flights/bookings/History'),
          meta: {
            title: 'Flight booking',
            roles: bookingRoles
          }
        }
      ]
    }
  ]
}
